import React, { useState, useMemo, forwardRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { ButtonBase } from '@material-ui/core';
import moment from 'moment';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { bsMlookupListFunc } from '../../../bsEnumeration';
import { EditIcon } from '../../../../../components/Icon';
import { classNames, conditional, initValue } from '../../../../../utils';
import PageList from '../../../../../components/PageList';
import { i18n } from '../../../../../language';
import TransferOutPop from '../../PopWindows/TransferOutPop';
import { LoginPop } from '../../../../../components/Login';
import StyleButton from '../../../../../components/StyleButton';
import { PatientUI } from '../../InternalBooking/TransferInTable/Row';
import { maskChineseName, maskEnglishName } from '../../../../../utils/admissionUtil';
import { AckInfo } from '../../../../Admission/components/BusStop/components';
const useStyles = makeStyles({
  root: ({ minHeight, padding }) => ({
    minHeight,
    overflow: 'auto',
    padding,
    backgroundColor: '#fff',
    flex: 1,
  }),
  tableBody: {},
  table: {
    position: 'relative',
    minWidth: '65rem',
    '& .MuiTableCell-root': {
      border: 'none',
      fontSize: '1rem',
      fontWeight: '500',
      lineHeight: '1.675rem',
      color: '#2e4469',
      padding: '0.813rem 1.25rem',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      left: '0',
      zIndex: '10',
      '& .MuiTableRow-root': {
        backgroundColor: '#fff',
      },
      '& .MuiTableCell-root': {
        fontWeight: 'bold',
        color: '#538fff',
        backgroundColor: '#fff',
        textTransform: 'uppercase',
      },
    },
    '& .MuiTableBody-root': {
      '& > :hover': {
        backgroundColor: '#f5faff',
      },
      '& > .MuiTableRow-root': {
        borderBottom: '1px solid #AAAAAA',
      },
      '& .MuiTableCell-root': {
        height: '3.5rem',
        fontFamily: 'NotoSans-Medium',
      },
    },
  },
  status: {
    width: '0.625rem',
    height: '0.625rem',
    display: 'inline-block',
    borderRadius: '50%',
    marginRight: '0.563rem',
  },
  editBtn: {
    width: '2.25rem',
    height: '2.25rem',
    minWidth: '0',
    backgroundColor: '#4c93ff',
    borderRadius: '0.625rem',
    color: '#fff',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  editIcon: {
    fontSize: '1rem',
    '&:hover': {
      background: '#4c93ff !important',
    },
  },
  tableHead: {
    whiteSpace: 'nowrap',
  },
  statusCell: {
    whiteSpace: 'nowrap',
  },
  patient: {
    overflowWrap: 'normal',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  },
  remark: {
    // whiteSpace: 'break-spaces',
  },
  admissionDate: {
    backgroundColor: '#fff3bb',
    borderRadius: '12px',
  },
});

export default forwardRef(function TransferOutTable(
  {
    className,
    allData,
    saveHandle,
    editPopChange,
    onRead,
    bsMlookupList,
    nextPageCall,
    pageSize,
    hideIndex,
    BsMlookupListAdd,
    ticket,
    handleAck,
    isHistory,
    minHeight = 'calc(100vh - 18rem)',
    padding = '0 1.875rem',
  },
  ref
) {
  const classes = useStyles({ minHeight, padding });
  const [isShowPop, setIsShowPop] = useState(false);
  const language = useSelector((state) => state.settings.language);
  const isLogin = useSelector((state) => state.loginInfo.flag);
  const [loginPopup, setLoginPopup] = useState(false);

  const showPop = (index) => {
    return () => {
      if (isLogin) {
        setEditIndex(index);
        setIsShowPop(true);
        if (typeof editPopChange === 'function') {
          editPopChange(true);
        }
      } else {
        setLoginPopup(true);
      }
    };
  };
  const closePop = () => {
    setIsShowPop(false);
    if (typeof editPopChange === 'function') {
      editPopChange(false);
    }
  };

  const isLoginName = (chiName) => {
    return conditional(chiName, `${chiName} `, '');
  };

  const isNotLoginName = (chiName) => {
    return conditional(chiName, `${maskChineseName(chiName)} `, '');
  };
  const dateTimeCtr = (targetArriveDtm) => {
    const dateTime = moment(targetArriveDtm);
    return dateTime.isValid() ? dateTime.format('YYYY-MM-DD HH:mm') : '';
  };
  const bsStatus = useMemo(() => {
    const statusList = bsMlookupListFunc.getBSBookStatusAddTranslate(bsMlookupList);
    const recvWardReady = { text: i18n.t('BEDSTATUS_RECV_WARD_READY'), value: 'RWR' };
    return [...statusList, recvWardReady];
  }, [bsMlookupList, language]);
  const bsMlookupListStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: i18n.t('BEDSTATUS_PENDING'), lookUpValue: 'P' },
      { lookUpName: i18n.t('BEDSTATUS_DELETED'), lookUpValue: 'D' },
    ];

    return addStatus;
  }, [bsMlookupList]);

  const statusCtr = (status) => {
    const styles = {
      O: { background: '#5cd9f4' },
      C: { background: '#28D2AB' },
      D: { background: '#C7C7C7' },
      PFYA: { background: '#ffc95c' },
      P: { background: '#ffc95c' },
      A: { background: '#5cd9f4' },
      DL: { background: '#ff655c' },
      RWR: { background: '#5cd9f4' },
    };
    const statusEnum =
      _.find(bsStatus, (item) => {
        return item.value === status;
      })?.text ?? '';
    return (
      <>
        <span className={classes.status} style={styles[status]} />
        {statusEnum}
      </>
    );
  };

  const editCtr = (index) => {
    return (
      <ButtonBase className={classes.editBtn} onClick={showPop(index)}>
        <EditIcon className={classes.editIcon} />
      </ButtonBase>
    );
  };

  const specialty_hospital_ward_bedNoCtr = (fromWardLocation, bedNo) => {
    return `${fromWardLocation ?? '-'} / ${bedNo ?? '-'}`;
  };

  const [EditIndex, setEditIndex] = useState(-1);
  const rows = useMemo(() => {
    return _.map(allData, (item, index) => {
      return {
        ...item,
        id: item.transferRequestId,
        status: statusCtr(item.status),
        requestDate: dateTimeCtr(item.requestDtm),
        admissionDate: dateTimeCtr(item.targetArriveDtm),
        // patient: patientCtr(item.patGender, item.caseNo, item.age),
        patient: {
          caseNo: item.caseNo,
          name: isLogin
            ? `${isLoginName(item.chiName)}${item.patName}`
            : `${isNotLoginName(item.chiName)}${maskEnglishName(item.patName)}`,
          gender: item.patGender,
          age: item.age,
        },
        edit: editCtr(index),
        ward_code_bed_No: specialty_hospital_ward_bedNoCtr(item.fromWardLocation, item.fromBedNo),
        principleDiagnosis: item.diagnosis ?? '',
        remark: item.remark,
        dest_hospital_ward: initValue(
          `${item?.destHospCode ?? '-'} / ${item.destWard ?? '-'} / ${item.destWardLocation ?? '-'}`
        ),
        ackDisplay: item.ackDisplay,
        adTicketId: item.adTicketId,
      };
    });
  }, [allData, language, isLogin, bsMlookupList]);

  const doubleClick = (index) => {
    return () => {
      if (isLogin) {
        showPop(index)();
      } else {
        setLoginPopup(true);
      }
    };
  };
  return (
    <PageList nextPageCall={nextPageCall} pageSize={pageSize} allData={allData} ref={ref} hideIndex={hideIndex}>
      <TableContainer className={classNames(className, classes.root)}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.tableHead} id="bed_transfer_tablehead">
            <TableRow>
              <TableCell align="left">{i18n.t('BEDSTATUS_STATUS')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_REQUEST_DATE')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_ADMISSION_DATE_TABLE')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_PATIENT')}</TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_WARD_BED_NO')}</TableCell>
              <TableCell align="left" style={{ minWidth: '20rem' }}>
                {i18n.t('BEDSTATUS_PRINCIPLE_DIAGNOSIS')}
              </TableCell>
              <TableCell align="left">{i18n.t('BEDSTATUS_REMARK')}</TableCell>
              <TableCell align="left">
                {i18n.t('BEDSTATUS_DEST_HOSPITAL_WARD')}
                <br />
              </TableCell>
              {isHistory && <TableCell align="left">Ack. Date, By, Type</TableCell>}
              {onRead ? null : <TableCell align="left">{i18n.t('BEDSTATUS_EDIT')}</TableCell>}
              {ticket && <TableCell align="left" />}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody} id="bed_transfer_tablebody">
            {rows?.map((row, index) => {
              const admissionDateBg = moment(row.admissionDate).valueOf() !== moment(row.requestDate).valueOf();
              return (
                <TableRow key={row.id} onDoubleClick={onRead ? null : doubleClick(index)} id={`bed_table_row${index}`}>
                  <TableCell align="left" className={classes.statusCell}>
                    {row.status}
                  </TableCell>
                  <TableCell align="left">{row.requestDate}</TableCell>

                  <TableCell align="left" className={admissionDateBg ? classes.admissionDate : ''}>
                    {row.admissionDate}
                  </TableCell>
                  <TableCell align="left">
                    <PatientUI iconBoxSize="2rem" {...row.patient} hkid={row.hkid} ehAddrInfo={row.ehAddrInfo} />
                  </TableCell>
                  <TableCell align="left">{row.ward_code_bed_No}</TableCell>
                  <TableCell align="left">
                    <div dangerouslySetInnerHTML={{ __html: row.principleDiagnosis?.replaceAll('\n', '<br/>') }} />
                  </TableCell>
                  <TableCell align="left" className={classes.remark}>
                    {row.remark}
                  </TableCell>
                  <TableCell align="left">{row.dest_hospital_ward}</TableCell>
                  {isHistory && (
                    <TableCell align="left">
                      <AckInfo ackBy={row.ackBy} ackDate={row.ackDate} adTicketType={row.adTicketType} />
                    </TableCell>
                  )}
                  {onRead ? null : (
                    <TableCell align="left" id={`bed_edit_btn${index}`}>
                      {row.edit}
                    </TableCell>
                  )}
                  {row.ackDisplay ? (
                    <TableCell>
                      <StyleButton
                        text="Ack."
                        width="3.875rem"
                        height="3rem"
                        type="fill"
                        onClick={handleAck(row.adTicketId)}
                      />
                    </TableCell>
                  ) : (
                    ''
                  )}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      {isShowPop ? (
        <TransferOutPop
          open={isShowPop}
          closePop={closePop}
          title={i18n.t('BEDSTATUS_TRANSFER_OUT_BUTTON')}
          allData={(() => {
            return EditIndex > -1 ? allData[EditIndex] : null;
          })()}
          saveHandle={async (data) => {
            if (saveHandle) {
              (await saveHandle(data, EditIndex)) && closePop();
            }
          }}
          bsMlookupList={bsMlookupList}
          bsMlookupListStatus={bsMlookupListStatus}
          covidPositivePatRemarks={false}
        />
      ) : (
        ''
      )}
      {loginPopup && <LoginPop closehandle={() => setLoginPopup(false)} submitHandle={() => setLoginPopup(false)} />}
    </PageList>
  );
});
